module.exports = __webpack_public_path__ + "static/media/GH1F.efd8c89d.jpg";